import React from "react";
import { Card, CardContent, Skeleton, Stack } from "@mui/material";

export default function CardSkeleton({ lines = 3 }) {
  return (
    <Card>
      <CardContent>
        <Skeleton variant="text" width="40%" height={28} />
        <Stack spacing={1} mt={1}>
          {Array.from({ length: lines }).map((_, i) => (
            <Skeleton key={i} variant="text" width={`${70 + ((i * 7) % 25)}%`} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
